var ChromecastSenderVideo = require('./ChromecastSenderVideo');

module.exports = ChromecastSenderVideo;
